import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs(props) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label={props.title1} {...a11yProps(0)} />
          <Tab label={props.title2} {...a11yProps(1)} />
          {!props.title3?<Tab label={props.title3} {...a11yProps(2)} />:null}          
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        {props.tab1}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        {props.tab2}
      </CustomTabPanel>
      {!props.title3?
      <CustomTabPanel value={value} index={2}>
        {props.tab3}
      </CustomTabPanel>
      :null}
    </Box>
  );
}

// ={!props.tab2.lenght===0}
// disabled={!props.tab2}